export type Token = {
  type: string;
  token: string;
};

export type Log = {
  category?: string;
  action?: string;
  label?: string;
  value?: string;
};

export type Generic = {
  id: number;
  usuario_id: number;
  cat: string;
  mat: string;
};

export type Motorista = Generic & {
  nome: string;
  email: string;
  placa: string;
  ativo: 0 | 1;
  perfil: 1 | 2;
};

export type Veiculo = Generic & {
  placa: string;
  ativo: 0 | 1;
};

export type Fornecedor = Generic & {
  uid?: string;
  nome?: string;
  razao?: string;
  cnpj: string;
  endereco?: string;
  mat: datetime;
};

export type Motivo = Generic & {
  nome: string;
  ativo: number;
  tipo: number;
};

export type Foa = Generic & {
  nome: string;
  ativo: number;
};

export type Fop = Generic & {
  nome: string;
  ativo: number;
};

export type TipoDeDespesa = Generic & {
  nome: string;
  ativo: number;
  requer_km: number;
  requer_litros: number;
  requer_veiculo: number;
  requer_nf: number;
};

export type Cliente = Generic & {
  nome: string;
  ativo: number;
  uid?: string;
  endereco: string | null;
  numero: string | null;
  cidade: string | null;
  bairro: string | null;
  uf: string | null;
  vendedor_id: number | null;
};

export const DEFAULT_DATETIME = '0000-00-00 00:00:00';

/**
 * ISO-9075
 * @default '0000-00-00 00:00:00'
 */
export type datetime = string;

export type Despesa = {
  conferido_em?: string;
  pago_em?: string;
  status?: string;
  id?: number;
  usuario_id?: number;
  cat?: string;
  mat: string;
  nf: string;
  uid?: string;
  motorista_id?: number | null;
  veiculo_id: number | null;
  fornecedor_id: number | string | null;
  // fop_id: number | null;
  reembolsavel: number;
  tipo_de_despesa_id: number;
  latitude: string | null;
  longitude: string | null;
  qrcode: string | null;
  em: datetime;
  valor_pago: string | null;
  descricao: string;
  comprovante: string | null;
  km: number | null;
  litros: number | null;

  recusada_em?: string;
  recusada_por?: string;

  valor_reembolsavel: string | null;
  valor_cartao_corporativo: string | null;
  valor_faturista: string | null;
};

export type Atendimento = {
  id?: number;
  usuario_id?: number;
  cat?: string;
  mat: string;
  uid?: string;

  inicio: string;
  fim: string;
  cliente: string;
  motivo_id: number | null;
  cliente_id?: number | null;
  foa_id: number | null;
  obs: string;
  valor: number;

  latitude: number;
  longitude: number;
  lat_lng_error?: string;

  // motorista_id?: number | null;
  // veiculo_id: number | null;
  // fornecedor_id: number | string | null;
  // tipo_de_despesa_id: number;
  // latitude: string | null;
  // longitude: string | null;
  // qrcode: string | null;
  // em: datetime;
  // valor_pago: string | null;
  // descricao: string;
  // comprovante: string | null;
  // km: number | null;
  // litros: number | null;
};

// export type DespesaToSync = {
//   uid: string;
//   veiculo_id: number;
//   fornecedor_id: number;
//   fop_id: number;
//   tipo_de_despesa_id: number;
//   latitude: string|null;
//   longitude: string|null;
//   qrcode: string|null;
//   em: datetime;
//   valor_pago: string;
//   descricao: string;
//   comprovante: string|null;
//   mat: datetime;
// }

export type Evento = {
  id?: number;
  usuario_id?: number;

  uid: string;
  inicio: string;
  fim: string | null;
  latitude: number;
  longitude: number;
  lat_lng_error?: string;
  duracao: number;
  descricao: EventoDescricao;
  motorista_id: number;
  veiculo_id: number;
  /** Criado em */
  cat?: datetime;
  /** Modificado em */
  mat: datetime;
  /** Deletado em */
  dat?: datetime;
  _inicio?: string;
  _fim?: string;
  _duracao?: string;
  obs: string;
  _obs?: string;
  cliente_id?: number | null;
  motivo_id?: number | null;
  motivo?: string; // for insert only
  cliente?: string; // for insert only
  km: number;
  foto_url?: string;
};

export const EVENTO_INICIO_DE_VIAGEM = 'Início da viagem';
export const EVENTO_FIM_DE_VIAGEM = 'Fim da viagem';
export const EVENTO_DIRECAO = 'Direção';
export const EVENTO_ESPERA = 'Espera';
export const EVENTO_REFEICAO = 'Refeição';
export const EVENTO_DESCANSO = 'Descanso';
export const EVENTO_CHECKIN = 'Check-in';

export type EventoDescricao =
  | 'Início da viagem'
  | 'Fim da viagem'
  | 'Direção'
  | 'Espera'
  | 'Refeição'
  | 'Descanso'
  | 'Check-in'
  | string;
